import { Helmet } from "react-helmet-async";
import LegalDoc from "@/components/LegalDoc";

const RefundPolicy = () => (
  <>
    <Helmet>
      <title>Refund & Returns Policy | Zentra</title>
      <meta
        name="description"
        content="Zentra's refund and returns policy for protein bar orders — damaged or incorrect items, cancellations and refund timelines."
      />
    </Helmet>
    <LegalDoc
      testId="refund-policy-page"
      title="Refund & Returns Policy"
      updated="July 2026"
      intro="This Refund & Returns Policy applies to purchases of ZENTRA products made on zentrafoods.in, operated by Mountain Fresh Farms LLP, Coimbatore, Tamil Nadu, India. As our products are food items, certain restrictions apply as described below."
      sections={[
        {
          heading: "1. General Policy",
          paragraphs: [
            "ZENTRA products are perishable food products. For hygiene and food-safety reasons, we do not accept returns or offer refunds for change of mind, taste preference, or products that have been opened, partially consumed or tampered with.",
          ],
        },
        {
          heading: "2. Damaged, Defective or Incorrect Products",
          paragraphs: [
            "If you receive a product that is damaged in transit, defective, expired or different from what you ordered, please report it to us within 48 hours of delivery [REVIEW] along with your order ID and clear photographs of the product and packaging.",
            "After verifying your claim, we will offer a free replacement or a full refund for the affected items, at our discretion and subject to stock availability [REVIEW].",
          ],
        },
        {
          heading: "3. Refund Timelines",
          list: [
            "Online payments (via PayU): approved refunds are credited to the original payment method within 5–7 business days [REVIEW], depending on your bank or payment provider.",
            "Cash on Delivery (COD) orders: approved refunds are issued via UPI or bank transfer within 5–7 business days [REVIEW] of receiving your account details.",
          ],
        },
        {
          heading: "4. Order Cancellations",
          paragraphs: [
            "You may cancel your order for a full refund at any time before it has been dispatched. Once an order has been dispatched, it cannot be cancelled. To request a cancellation, contact us as soon as possible with your order ID.",
          ],
        },
        {
          heading: "5. Non-Refundable Situations",
          list: [
            "Products that have been opened, used or are not in their original packaging",
            "Delays in delivery caused by the courier partner or events beyond our control",
            "Failed deliveries resulting from an incorrect address or unreachable phone number provided by the customer",
            "Claims reported after 48 hours of delivery [REVIEW]",
          ],
        },
        {
          heading: "6. How to Request a Refund",
          paragraphs: [
            "Email us at info@zentrafoods.in or message us on WhatsApp at +91 90031 40803 with your order ID, a description of the issue and photographs where applicable. We aim to respond to all refund requests within 2 business days [REVIEW].",
          ],
        },
      ]}
    />
  </>
);

export default RefundPolicy;
